import { render, staticRenderFns } from "./publicBottom.vue?vue&type=template&id=11067052&scoped=true"
import script from "./publicBottom.vue?vue&type=script&lang=js"
export * from "./publicBottom.vue?vue&type=script&lang=js"
import style0 from "./publicBottom.vue?vue&type=style&index=0&id=11067052&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11067052",
  null
  
)

export default component.exports